import script from "./AccountNumberViewChange.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountNumberViewChange.vue?vue&type=script&setup=true&lang=js"

import "./AccountNumberViewChange.vue?vue&type=style&index=0&id=3b6f5788&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b6f5788"]])

export default __exports__